<style>
.ag-theme-material .ag-cell {
    line-height: 35px !important;
}
.status-badge {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
}
.status-menunggu-pks    { background: #FFF3CD; color: #856404; }
.status-menunggu-rh2    { background: #CCE5FF; color: #004085; }
.status-persiapan       { background: #D4EDDA; color: #155724; }
.status-proses          { background: #D1ECF1; color: #0C5460; }
.status-bast            { background: #E2D9F3; color: #4A235A; }
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card class="p-4 mb-6">
            <div class="flex flex-wrap items-center justify-between mb-10">
                <div class="flex items-center">
                    <h4 style="margin-left: 10px">Monitor Surat Pesanan</h4>
                </div>
                <div class="flex items-center">
                    <vs-button
                        @click="fetchData"
                        class="mb-4 mr-1 btn md:mb-0"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        class="mb-4 mr-1 md:mb-0"
                        icon="how_to_vote"
                        :disabled="!selectedId"
                        @click="goToApproval"
                    >Approval</vs-button>
                    <vs-button
                        class="mb-4 mr-1 md:mb-0"
                        icon="filter_list"
                        @click="showFilter = true"
                    >Filter</vs-button>
                </div>
            </div>

            <ag-grid-vue
                :gridOptions="gridOptions"
                class="my-4 ag-theme-material w-100 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="rows"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="goToApproval"
            ></ag-grid-vue>

            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
        </vx-card>

        <!-- Filter -->
        <vs-prompt @accept="fetchData" title="Filter" :active.sync="showFilter">
            <div class="con-exemple-prompt">
                <vs-input v-model="filter.nomor_pesanan" class="w-full mb-2" label="No. Pesanan" />
                <vs-input v-model="filter.obyek" class="w-full mb-2" label="Obyek" />
                <label class="vs-input--label">Status</label>
                <vs-select class="mb-2 selectExample" v-model="filter.status" width="100%">
                    <vs-select-item
                        v-for="(s, i) in statusOptions"
                        :key="i"
                        :value="s.value"
                        :text="s.label"
                    />
                </vs-select>
                <label class="vs-input--label">Tanggal Pesan</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5" style="padding-left:0">
                        <flat-pickr class="w-full p-2 vx-col" v-model="filter.tanggal_start" />
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">To</vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="5" style="padding-right:0">
                        <flat-pickr class="w-full p-2 vx-col" v-model="filter.tanggal_end" />
                    </vs-col>
                </vs-row>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

const STATUS_MAP = {
    'menunggu_pks': { label: 'Menunggu Persetujuan Regional Head PKS', css: 'status-menunggu-pks' },
    'menunggu_rh2': { label: 'Menunggu Persetujuan Regional Head 2',   css: 'status-menunggu-rh2' },
    'persiapan':    { label: 'Persiapan Produksi',                      css: 'status-persiapan' },
    'proses':       { label: 'Proses Produksi',                         css: 'status-proses' },
    'bast':         { label: 'BAST',                                    css: 'status-bast' },
}

export default {
    components: { AgGridVue, flatPickr },
    data() {
        return {
            gridOptions: {},
            columnDefs: null,
            defaultColDef: { sortable: true, editable: false, resizable: true, suppressMenu: true },
            rows: [
                {
                    id: 1,
                    nomor_pesanan: 'SP/SG/2025/001',
                    pks: 'SEI GARO',
                    obyek: 'PENGADAAN DAN PEMBUATAN BARU LORI REBUSAN 2,5 TON 10 (SEPULUH) UNIT',
                    tanggal_pesan: '2025-09-20',
                    ekspektasi_selesai: '2025-11-30',
                    status: 'menunggu_pks',
                    created_by: 'Budi Santoso',
                    created_at: '2025-09-20 08:30:00',
                    has_new_komentar: true,
                },
                {
                    id: 2,
                    nomor_pesanan: 'SP/SG/2025/002',
                    pks: 'SEI GARO',
                    obyek: 'PERBAIKAN DAN OVERHAUL HYDROCYCLONE UNIT 3',
                    tanggal_pesan: '2025-09-22',
                    ekspektasi_selesai: '2025-12-15',
                    status: 'menunggu_rh2',
                    created_by: 'Andi Wijaya',
                    created_at: '2025-09-22 09:15:00',
                    has_new_komentar: false,
                },
                {
                    id: 3,
                    nomor_pesanan: 'SP/BJ/2025/003',
                    pks: 'BATU LANGKA',
                    obyek: 'PENGGANTIAN BANTALAN DAN SEAL CAKE BREAKER CONVEYOR (CBC)',
                    tanggal_pesan: '2025-10-01',
                    ekspektasi_selesai: '2025-11-20',
                    status: 'persiapan',
                    created_by: 'Rini Marlina',
                    created_at: '2025-10-01 10:00:00',
                    has_new_komentar: false,
                },
                {
                    id: 4,
                    nomor_pesanan: 'SP/BJ/2025/004',
                    pks: 'BATU LANGKA',
                    obyek: 'PENGADAAN SUKU CADANG POLISHING DRUM 5 UNIT',
                    tanggal_pesan: '2025-10-05',
                    ekspektasi_selesai: '2025-12-01',
                    status: 'proses',
                    created_by: 'Hendra Kurniawan',
                    created_at: '2025-10-05 14:20:00',
                    has_new_komentar: true,
                },
                {
                    id: 5,
                    nomor_pesanan: 'SP/TG/2025/005',
                    pks: 'TORGAMBA',
                    obyek: 'PERBAIKAN LTDS (LIGHT TENERA DUST SEPARATOR) UNIT 1 DAN 2',
                    tanggal_pesan: '2025-08-15',
                    ekspektasi_selesai: '2025-10-30',
                    status: 'bast',
                    created_by: 'Sari Dewi',
                    created_at: '2025-08-15 11:45:00',
                    has_new_komentar: false,
                },
                {
                    id: 6,
                    nomor_pesanan: 'SP/TG/2025/006',
                    pks: 'TORGAMBA',
                    obyek: 'PEMBUATAN DAN PEMASANGAN BANTINGAN (THRESHER) DRUM BARU',
                    tanggal_pesan: '2025-10-10',
                    ekspektasi_selesai: '2026-01-15',
                    status: 'menunggu_pks',
                    created_by: 'Irwan Pratama',
                    created_at: '2025-10-10 08:00:00',
                    has_new_komentar: true,
                },
            ],
            selectedId: null,
            selectedRow: null,
            isLoading: false,
            totalPage: 1,
            currentPage: 1,
            dataFrom: 1,
            dataTo: 6,
            dataTotal: 6,
            showFilter: false,
            filter: {
                nomor_pesanan: '',
                obyek: '',
                status: null,
                tanggal_start: null,
                tanggal_end: null,
            },
            statusOptions: [
                { value: null,           label: 'Semua' },
                { value: 'menunggu_pks', label: 'Menunggu Persetujuan Regional Head PKS' },
                { value: 'menunggu_rh2', label: 'Menunggu Persetujuan Regional Head 2' },
                { value: 'persiapan',    label: 'Persiapan Produksi' },
                { value: 'proses',       label: 'Proses Produksi' },
                { value: 'bast',         label: 'BAST' },
            ],
        }
    },
    watch: {
        isLoading(val) {
            if (val) this.$vs.loading()
            else this.$vs.loading.close()
        },
        currentPage() {
            this.fetchData()
        },
    },
    methods: {
        onSelectionChanged() {
            const rows = this.gridApi.getSelectedRows()
            if (rows.length > 0) {
                this.selectedId = rows[0].id
                this.selectedRow = rows[0]
            } else {
                this.selectedId = null
                this.selectedRow = null
            }
        },
        goToApproval() {
            if (!this.selectedId) return
            this.$router.push({ name: 'surat-pesanan-approval', params: { id: this.selectedId } })
        },
        fetchData() {
            // data hardcode — ganti dengan pemanggilan API saat backend siap
        },
        statusLabel(value) {
            return STATUS_MAP[value] ? STATUS_MAP[value].label : (value || '-')
        },
        statusCss(value) {
            return STATUS_MAP[value] ? STATUS_MAP[value].css : ''
        },
    },
    mounted() {
        this.gridApi = this.gridOptions.api
        this.fetchData()
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: '',
                field: 'has_new_komentar',
                width: 46,
                sortable: false,
                resizable: false,
                cellRenderer: params => {
                    if (!params.value) return ''
                    return `<span title="Ada komentar negosiasi baru" style="display:flex;align-items:center;height:100%"><span class="material-icons" style="font-size:20px;color:#f59e0b">chat</span></span>`
                },
            },
            { headerName: 'No. Pesanan', field: 'nomor_pesanan', width: 160, filter: true },
            { headerName: 'PKS',         field: 'pks',           width: 130, filter: true },
            { headerName: 'Obyek',       field: 'obyek',         width: 320, filter: true },
            { headerName: 'Tanggal Pesan', field: 'tanggal_pesan', width: 130, filter: true },
            { headerName: 'Ekspektasi Selesai', field: 'ekspektasi_selesai', width: 150, filter: true },
            {
                headerName: 'Status',
                field: 'status',
                width: 300,
                filter: true,
                cellRenderer: params => {
                    const map = {
                        'menunggu_pks': { label: 'Menunggu Persetujuan Regional Head PKS', bg: '#FFF3CD', color: '#856404' },
                        'menunggu_rh2': { label: 'Menunggu Persetujuan Regional Head 2',   bg: '#CCE5FF', color: '#004085' },
                        'persiapan':    { label: 'Persiapan Produksi',                      bg: '#D4EDDA', color: '#155724' },
                        'proses':       { label: 'Proses Produksi',                         bg: '#D1ECF1', color: '#0C5460' },
                        'bast':         { label: 'BAST',                                    bg: '#E2D9F3', color: '#4A235A' },
                    }
                    const s = map[params.value]
                    if (!s) return params.value || '-'
                    return `<span style="display:inline-block;padding:2px 10px;border-radius:12px;font-size:11px;font-weight:600;background:${s.bg};color:${s.color}">${s.label}</span>`
                },
            },
            { headerName: 'Dibuat Oleh', field: 'created_by', width: 150, filter: true },
            { headerName: 'Tanggal Buat', field: 'created_at', width: 150, filter: true },
        ]
        this.gridOptions.getRowHeight = () => 35
    },
}
</script>
